if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.sticky-add-to-cart__button');
        this.button.addEventListener('click', () => this.targetButton && this.targetButton.click());
      }

      connectedCallback() {
        this.targetButton = document.getElementById(this.dataset.targetButton);
        if (!this.targetButton) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            this.classList.toggle('sticky-add-to-cart--visible', !entries[0].isIntersecting);
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this.observer.observe(this.targetButton);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
